module.exports = __webpack_public_path__ + "static/favicon-875210241c4b4c26c3bf48add87cc6f8.png";